function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useEffect, useState, useRef } from 'react';
import useShoppingCartQuery from './useShoppingCartQuery';
import mse from '@adobe/magento-storefront-events-sdk';
import processGraphQLResponse from '../util/processGraphQLResponse';
var useCart = () => {
  var {
    data: currentCart
  } = useShoppingCartQuery({
    fetchPolicy: 'cache-first'
  });
  var [previousCart, setPreviousCart] = useState(currentCart);
  var initialPageLoad = useRef(false);
  var getNewCart = () => {
    var newCart = processGraphQLResponse(currentCart.cart);
    newCart.items = newCart.items.map(item => _objectSpread(_objectSpread({}, item), {}, {
      formattedPrice: item.prices.price.value,
      canApplyMsrp: false,
      product: _objectSpread(_objectSpread({}, item.product), {}, {
        productId: item.product.id
      })
    }));
    return newCart;
  };
  useEffect(() => {
    if (currentCart && currentCart.cart && currentCart.cart.items) {
      if (previousCart && previousCart.cart && previousCart.cart.items) {
        var prevCartLength = previousCart.cart.items.length;
        var currentCartLength = currentCart.cart.items.length;
        if (currentCartLength < prevCartLength) {
          var newCart = getNewCart();
          // remove item
          mse.context.setShoppingCart(newCart);
          mse.publish.removeFromCart();
        } else if (currentCartLength > prevCartLength) {
          var _newCart = getNewCart();
          // add item
          mse.context.setShoppingCart(_newCart);
          mse.publish.addToCart();
        }
      }
      setPreviousCart(currentCart);
      if (!initialPageLoad.current) {
        var _newCart2 = getNewCart();
        mse.context.setShoppingCart(_newCart2);
        initialPageLoad.current = true;
      }
    }
  }, [currentCart, previousCart]);
};
export default useCart;